import { useQuery, useMutation, useQueryClient } from 'react-query';
import { ServerErrorResponse, baseApiUrl, fetcher } from 'data_sources/constants';
import {
  RiskPoolPolicyConfigResponse,
  UpdateRiskPoolPolicyConfigPayload,
  RiskPoolPolicySolution
} from '../../../../_types/solution';

// API functions
const getRiskPoolPolicyConfig = async (orgId: string): Promise<RiskPoolPolicyConfigResponse> => {
  const url = `${baseApiUrl()}/admin-solution/v1/organizations/${orgId}/solutions/policy/risk-pool/config`;

  const data: RiskPoolPolicyConfigResponse = await fetcher({
    url,
    method: 'get',
  });

  return data;
};

const updateRiskPoolPolicyConfig = async (orgId: string, data: UpdateRiskPoolPolicyConfigPayload): Promise<RiskPoolPolicyConfigResponse> => {
  const url = `${baseApiUrl()}/admin-solution/v1/organizations/${orgId}/solutions/policy/risk-pool/config`;

  const response: RiskPoolPolicyConfigResponse = await fetcher({
    url,
    method: 'put',
    body: data,
  });

  return response;
};

// Hooks
export const useRiskPoolPolicyConfig = (orgId: string, options = {}) => {
  return useQuery<RiskPoolPolicyConfigResponse, ServerErrorResponse>(
    ['riskPoolPolicyConfig', orgId],
    () => getRiskPoolPolicyConfig(orgId),
    {
      enabled: !!orgId,
      ...options,
    }
  );
};

export const useUpdateRiskPoolPolicyConfig = () => {
  const queryClient = useQueryClient();

  return useMutation<RiskPoolPolicyConfigResponse, ServerErrorResponse, { orgId: string; data: UpdateRiskPoolPolicyConfigPayload; }>(
    ({ orgId, data }) => updateRiskPoolPolicyConfig(orgId, data),
    {
      onSuccess: (data, { orgId }) => {
        queryClient.setQueryData(['riskPoolPolicyConfig', orgId], data);
        queryClient.invalidateQueries(['riskPoolPolicyConfig', orgId]);
      },
    }
  );
};
